module.exports = __webpack_public_path__ + "img/colors-universe.f9734b91.png";